export default "__VITE_ASSET__48YfLVnP__"